import { useAppDispatch } from "@/store/hooks";
import { setSelectedId } from "@/store/slideEditorSlice";
import { BsQuestionSquare } from "react-icons/bs";
import { HiArrowLeft } from "react-icons/hi";
import { IoShapesOutline } from "react-icons/io5";
import { LuImages, LuPaintbrush } from "react-icons/lu";
import { MdFormatColorText, MdOutlineEmojiEmotions, MdOutlineLayers } from "react-icons/md";
import { TbAlphabetLatin } from "react-icons/tb";
import { Sidebar } from "../../sidebars/Sidebar";
import { useSlideEditorContext } from "../editor/SlideEditorContext";
import { ToolbarPanelContainer } from "./ToolbarPanelContainer";

/**
 * Navigation item configuration
 */
interface NavItem {
  label: string;
  icon: React.ReactNode;
}

const navItems: NavItem[] = [
  {
    label: "Shapes",
    icon: <IoShapesOutline fontSize={24} />,
  },
  {
    label: "Text",
    icon: <MdFormatColorText fontSize={24} />,
  },
  // {
  //   label: "Graphics",
  //   icon: <MdOutlineEmojiEmotions fontSize={24} />,
  // },
  {
    label: "Questions",
    icon: <BsQuestionSquare fontSize={24} />,
  },
  {
    label: "Media",
    icon: <LuImages fontSize={24} />,
  },
  {
    label: "Phonics",
    icon: <TbAlphabetLatin fontSize={24} />,
  },
  {
    label: "Layers",
    icon: <MdOutlineLayers fontSize={24} />,
  },
  {
    label: "Styles",
    icon: <LuPaintbrush fontSize={24} />,
  },
];

export type NavLabel = (typeof navItems)[number]["label"];

/**
 * Main sidebar component for slide editor
 */

export function SlideToolbar({ onBack }: { onBack?: () => void }) {
  const dispatch = useAppDispatch();
  const { activePanel, setActivePanel } = useSlideEditorContext();

  const handleClick = (item: NavItem) => {
    dispatch(setSelectedId(null));
    setActivePanel(item.label);
  };

  return (
    <>
      <Sidebar>
        {onBack && (
          <>
            <button
              type="button"
              onClick={onBack}
              aria-label="Back to slides"
              className="nav-glow-effect nav-item-inactive w-16 h-16 flex-col text-gray-700 dark:text-gray-200"
            >
              <HiArrowLeft fontSize={22} />
              <span className="caption">Slides</span>
            </button>
            <div className="w-10 h-px shrink-0 my-1 bg-gray-200 dark:bg-gray-800" />
          </>
        )}
        {navItems.map((item) => {
          const isActive = item.label === activePanel;

          return (
            <button
              key={item.label}
              type="button"
              onClick={() => handleClick(item)}
              aria-label={item.label}
              aria-current={isActive ? "page" : undefined}
              className={`nav-glow-effect ${isActive ? "nav-item-active" : "nav-item-inactive"} w-16 h-16 flex-col`}
            >
              {item.icon}
              <span className="caption">{item.label}</span>
            </button>
          );
        })}
      </Sidebar>

      {/* Expandable tool properties panel */}
      {activePanel && (
        <div className="absolute left-20 top-0 h-full shadow-lg z-[900]">
          <ToolbarPanelContainer />
        </div>
      )}
    </>
  );
}
